import { InputAdornment, Link } from "@mui/material";
import { TextField } from "components/form/TextField";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

interface Props {
  label: string;
  link: string;
}

export function ShareLinkTextField(props: Props) {
  const { label, link } = props;

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  function copyUrlToClipboard() {
    navigator.clipboard.writeText(link);
    enqueueSnackbar(t("label.LinkSuccessfullyCopied"), { variant: "success" });
  }

  return (
    <TextField
      variant="outlined"
      aria-readonly
      size="small"
      label={label}
      value={link}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Link onClick={copyUrlToClipboard}>{t("label.copy")}</Link>
          </InputAdornment>
        ),
      }}
    />
  );
}
